import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';

/** Queries: 30 s fresh, no refetch on focus, retries only for network/5xx errors. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      },
    },
  });
}
